import {Namespace} from 'i18next';

import {i18n} from './i18n';
import {TFunction} from './t-function';

/**
 * Returns a fixed translation function for the requested namespace.
 *
 * @param namespace Translation namespace to bind.
 * @returns Namespace-scoped translation helper.
 *
 * @example
 * const tt = t('common');
 * tt('save');
 */
export const t = <T extends Namespace>(namespace: T): TFunction<T> => i18n.getFixedT(null, namespace);
/**
 * Fixed translation helper for the shared common namespace.
 *
 * @returns Translation helper bound to the `common` namespace.
 *
 * @example
 * tCommon('save');
 */
export const tCommon = t('common');
